// extracted by mini-css-extract-plugin
export default {"expandButton":"expand_button_expandButton__RwMHJ","arrowIcon":"expand_button_arrowIcon__poFWS","arrowIconInverted":"expand_button_arrowIconInverted__U6Nkt"};